import P from "components/P";
import FlexChild from "layouts/flex/FlexChild";
import VerticalFlex from "layouts/flex/VerticalFlex";
import Center from "layouts/wrapper/Center";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import { useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import testProductBg from "resources/test/testProductBg.png";
import { CartReducer } from "shared/redux/reducers/shopping/CartReducer";
import style from "./ProductCard.module.css";
import rank1Icon from "resources/img/puffu/rank1.png";
import rank2Icon from "resources/img/puffu/rank2.png";
import rank3Icon from "resources/img/puffu/rank3.png";
import { useNavigate, useParams } from "react-router-dom";

function MobilePuffuOrderCard(props) {
    const { isMobile } = useContext(BrowserDetectContext);
    const { data } = props;
    const dispatch = useDispatch();
    const { id } = useParams();
    const navigate = useNavigate();
    const onClickProduct = () => {

        navigate(`/ws/${id}/mobile/detail/${data.id}`, { state: { data: data } })
    }
    const addCartClick = () => {
        dispatch(CartReducer.actions.addProductToCart({ ...data, quantity: 1 }));
        // return (
        //     audioRef.current.play()
        // );
    }
    const getRankIcon = (rank) => {
        switch (rank) {
            case 1:
                return rank1Icon;
            case 2:
                return rank2Icon;
            case 3:
                return rank3Icon;
            default:
                return null;
        }
    }

    const rankIcon = getRankIcon(data.productRank);

    return (
        <div
            style={{
                display: "flex",
                flex: "1 0 20%",
                justifyContent: "center",
                alignItems: "center",
                border: "1.5px solid #bbb",
                borderRadius: "3px"

            }}
        >
            <div
                style={{
                    width: "100%",
                    position: "relative"
                }}
            >
                <div className={style.rankLabel}>
                    <VerticalFlex width={"max-content"} gap={5}>
                        {
                            data.productRank !== null &&
                            <FlexChild>
                                <img src={rankIcon} width={"30px"} />
                            </FlexChild>
                        }
                        {
                            data.newYn &&
                            <FlexChild>
                                <div className={style.new}>
                                    <P color={"white"} size={12} font={"Pretendard"} weight={700}>NEW</P>
                                </div>
                            </FlexChild>
                        }
                    </VerticalFlex>
                </div>

                <VerticalFlex gap={10}>

                    <FlexChild>
                        <div
                            style={{
                                borderTopLeftRadius: "3px",
                                borderTopRightRadius: "3px",
                                padding: "10px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                // backgroundImage: data.productBgImg ? `url(${data.productBgImg})` : `url(${testProductBg})`,
                                backgroundSize: "cover"

                            }}
                            onClick={onClickProduct}
                        >
                            <img src={data.productImg} width={"78%"} />
                        </div>
                    </FlexChild>
                    <FlexChild>
                        <Center width={"130px"}>
                            <P font={"Pretendard"} weight={500} ellipsis size={isMobile ? "14px" : 15}>
                                {data.productName}
                            </P>
                            <P font={"Pretendard"} weight={700} color={"var(--point-color)"} size={20}>
                                {data.price ? data.price.toLocaleString() : '가격 없음'}원
                            </P>
                        </Center>
                    </FlexChild>
                    <FlexChild width={"100%"}>
                        <div style={{ backgroundColor: "var(--point-color)", cursor: "pointer" }} onClick={addCartClick}>
                            <Center>
                                <P
                                    size={18}
                                    width={"100%"}
                                    color={"white"}
                                    padding={"5px 15px"}
                                    cursor={"pointer"}
                                    font={"Pretendard"}
                                    weight={700}
                                >
                                    담기
                                </P>
                            </Center>
                        </div>
                    </FlexChild>
                </VerticalFlex>
            </div>
        </div>
    );
};

export default MobilePuffuOrderCard;